import { ContactListPage } from "@/features/contact/pages/ContactList";
import { ContactFilterCacheProvider } from "@/features/contact/provider/ContactListFilterCacheProvider";
import { FC } from "react";

type TContactListProps = {
  isCompany: boolean;
};

const ContactList: FC<TContactListProps> = ({ isCompany }) => {
  return (
    <ContactFilterCacheProvider>
      <ContactListPage isCompany={isCompany} />
    </ContactFilterCacheProvider>
  );
};

export default ContactList;
